<template>
  <div id="brochure-layout">
    <app-navbar />
    <router-view />
  </div>
</template>

<script>
import appNavbar from '@/layouts/brochure/brochure-navbar.vue'
export default {
  name: 'Main',
  components: {
    appNavbar
  }
}
</script>
<style scoped>
@font-face {
  font-family: "Raleway";
  src: local("Raleway"),
    url(../../assets/fonts/Raleway-VariableFont_wght.ttf) format("truetype");
}
</style>
